import '../assets/styles/Footer.scss'

function Footer() {
  return (
    <footer>
      {/* <div>
        <a href="https://github.com/yujisatojr" target="_blank" rel="noreferrer"><GitHubIcon/></a>
        <a href="https://www.linkedin.com/in/yujisato/" target="_blank" rel="noreferrer"><LinkedInIcon/></a>
      </div> */}
      <p>This portfolio template was forked from <a href="https://github.com/yujisatojr/react-portfolio-template" target="_blank" rel="noreferrer">Yuji Sato's repository</a></p>
    </footer>
  );
}

export default Footer;